
const benefits = [
  {
    icon: 'ri-vip-crown-line',
    title: 'Concierge-Level Service',
    description: 'We provide white-glove service tailored to busy professionals. From plan selection to claims resolution, we handle every detail so you can focus on what matters most.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Independent & Unbiased',
    description: 'Unlike captive agents, we partner with 20+ top-rated carriers including Aetna, Blue Cross, Cigna, and UnitedHealthcare — ensuring you get the best coverage at competitive rates.'
  },
  {
    icon: 'ri-stethoscope-line',
    title: 'Premium Provider Access',
    description: 'Our plans include access to UT Southwestern, Baylor Scott & White, Texas Health Presbyterian, and Dallas\'s finest specialists and medical institutions.'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Claims Advocacy',
    description: 'When you need help with a claim or billing issue, your dedicated advisor steps in immediately. We advocate on your behalf to ensure swift, fair resolution every time.'
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Zero Cost to You',
    description: 'Our expert guidance, plan comparisons, and enrollment support are completely free. We\'re compensated by carriers, saving you money while delivering premium service.'
  },
  {
    icon: 'ri-map-pin-user-line',
    title: 'Deep Dallas Expertise',
    description: 'With 15+ years serving Highland Park, University Park, Preston Hollow, and Park Cities, we understand the local healthcare landscape and provider networks intimately.'
  }
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-primary">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-widest text-secondary uppercase mb-4">The Dallas Difference</span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
            Why Dallas&apos;s <strong>Elite Families</strong> Choose Us
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Experience the difference of working with an independent agency that delivers concierge-level private health insurance service.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-white/10 hover:bg-white/10 transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-secondary/15 rounded-lg mb-6 group-hover:bg-secondary/25 transition-all">
                <i className={`${benefit.icon} text-2xl text-secondary`}></i>
              </div>

              <h3 className="text-xl font-bold text-white mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-300 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-base text-gray-300 mb-6">
            Ready to experience premium health insurance protection?
          </p>
          <a
            href="tel:2143060121"
            className="whitespace-nowrap inline-flex items-center gap-3 px-8 py-4 bg-secondary hover:bg-secondary/90 text-white text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            <i className="ri-phone-line text-xl"></i>
            Call (214) 306-0121
          </a>
        </div>
      </div>
    </section>
  );
}
